module.exports = __webpack_public_path__ + "img/yx4.a91a7352.jpg";